import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";

interface AccordionProps {
  title: string;
  description: string;
}

const Accordion: React.FC<AccordionProps> = ({ title, description }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="bg-[#F2F2F2] rounded-2xl p-4">
      <div className="flex items-center justify-between">
        <div className="text-[var(--app-primary)] text-lg font-semibold">
          {title}
        </div>
        <button
          className="cursor-pointer bg-[var(--app-primary)] rounded-full p-1 text-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <ChevronUp /> : <ChevronDown />}
        </button>
      </div>
      {isOpen && (
        <div
          className="text-gray-600 text-base font-normal mt-4"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      )}
    </div>
  );
};

export default Accordion;
